<template>
  <div class="user-message">
    <div class="titles-right font-style">我的证书</div>
    <div class="flex">
      <div class="ma-t-20 flex ma-r-20" v-for="(item, index) in dataList" :key="index">
      <div class="t-center">
        <img :src="item.CertificatePath" class="img_certificate" />
        <div class="">
          {{item.CertificateName}}
        </div>
      </div>
    </div>
    </div>

    <div v-if="dataList.length==0" class="pa-t-100">
      <Empty></Empty>
    </div>

  </div>
</template>

<script>
import { getMycertificate } from "../api";
export default {
  name: "mycertificate",
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    this.loadDataList();
  },
  methods: {
    loadDataList() {
        getMycertificate().then((res) => {
          this.dataList = res.data.Data;
        });
    },
  },
};
</script>

<style >
.titles-right:before {
  content: "|";
  display: inline-block;
  width: 4px;
  height: 19px;
  background: #234775;
  color: #234775;
  border-radius: 2px;
  margin-right: 8px;
}
.width920px {
  width: 920px;
}
.font-style {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
}
.tab-active {
  border-bottom: 2px solid #234775;
}

.img_certificate {
  width: 180px;
  height: 230px;
}
</style>